"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createURLSearchParams(data) {
    var params = new URLSearchParams();
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        if (Array.isArray(data[key])) {
            for (var _b = 0, _c = data[key]; _b < _c.length; _b++) {
                var item = _c[_b];
                if (item !== null && item !== undefined) {
                    params.append(key, item);
                }
            }
        }
        else {
            if (data[key] !== null && data[key] !== undefined) {
                params.append(key, data[key]);
            }
        }
    }
    return params;
}
exports.createURLSearchParams = createURLSearchParams;
